import styled from '@emotion/styled'

export const Form = styled.form`
  grid-gap: ${({ theme }) => theme.spacing.md};
  display: grid;
  max-width: 800px;
  margin: auto;

  label {
    margin-bottom: 0;
  }

  input,
  textarea,
  select {
    width: 100%;
  }

  textarea {
    min-height: 230px;
  }
`

export const ResultMessage = styled.div`
  color: ${({ theme, hasError }) =>
    hasError ? theme.colors.error.base.hex : 'inherit'};
`
